import type { SupportedLanguage, ThirdPartyLocalization } from "@/shared/types/i18n";

export const ZodLocalization: ThirdPartyLocalization = {
  changeLanguage: (language: SupportedLanguage): void => {
    // Update the Zod error messages with the new language
    
  },
};
